import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './index.css';

const LOADING_CONTEXT = '__loading__';

function LoadingIcon({icon, style}, context) {
  const { opacity } = context[LOADING_CONTEXT];
  return icon ? <i style={style} className={`fas loading-icon ${icon}`} /> : null;
}
LoadingIcon.contextTypes = {
  [LOADING_CONTEXT]: PropTypes.object.isRequired,
}

function LoadingComponent({component: InnerComponent, style, children}, context) {
  const { opacity } = context[LOADING_CONTEXT];
  return InnerComponent ? <div className="loading-component-container"><InnerComponent style={style} />{children}</div> : null;
}
LoadingComponent.contextTypes = {
  [LOADING_CONTEXT]: PropTypes.object.isRequired,
}

function LoadingLabel({label, style}, context) {
  const { opacity } = context[LOADING_CONTEXT];
  return label ? <div style={style} className="loading-label">{label}</div> : null;
}
LoadingLabel.contextTypes = {
  [LOADING_CONTEXT]: PropTypes.object.isRequired,
}

class Loading extends Component {
  static Icon = LoadingIcon;
  static Component = LoadingComponent;
  static Label = LoadingLabel;
  static defaultProps = {show: false}
  static childContextTypes = {
    [LOADING_CONTEXT]: PropTypes.object.isRequired,
  }
  getChildContext() {
    const { opacity } = this.props;
    return {
      [LOADING_CONTEXT]: {
        opacity,
      }
    }
  }
  render() {
    const { show, children, style, onClick } = this.props;
    return show ? <div onClick={onClick} style={style} className="loading-background">{children}</div> : false
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js